import gtm from '@/utils/gtm';
import { currencySymbolBack, currencySymbolLocalMap } from '@elem/ui-common/utils/FormatMoneyLocal';
import classNames from 'classnames';
import { useRouter } from 'next/router';
import React from 'react';
import EfImg from '../ef-img';
import EfMessage, { EfMessageGlobal } from '../ef-message';
import { copyText } from './comps/copyText';
import IconCopy from './comps/IconCopy';
import { getTextToLang, langText } from './comps/langText';
import './index.scss';

export interface EfCouponTopProps {
    /**
     * 图片资源
     */
    pc?: string;
    /**
     * 样式名
     */
    className?: string;
    /**
     * 是否显示 couponName
     */
    showCouponName?: string;
    /**
     * 后台传达的数据
     */
    sqlItemData?: any;
    /**
     * 埋点-复制
     */
    dataLayer_copy?: any;
}

/**
 * 维护:谢保林
 *
 * 优惠券
 */
const EfCouponTop: React.FC<EfCouponTopProps> = ({ showCouponName, sqlItemData = {}, className, dataLayer_copy }) => {
    const prefixCls = `ef-coupon-top`;
    const { locale = 'us' } = useRouter();
    // 单位在左
    const isUnitRight = currencySymbolBack.includes(locale);
    // 是百分比
    const isPercentage = sqlItemData?.discountType === 'percentage';

    const TextA = langText[locale] || langText['us'];
    const currencySymbol = currencySymbolLocalMap[locale] || currencySymbolLocalMap['us'];
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
        [`${prefixCls}-unit-right`]: isUnitRight && !isPercentage,
    });
    const pc2 = sqlItemData.rulePic || 'https://websiteoss.ecoflow.com/upload/image/1733228212176/bg2.png';

    //
    let minimum_rule = '';
    const prerequisiteRange = sqlItemData.prerequisiteRange;
    const prerequisite = sqlItemData.prerequisite;
    if (prerequisite === 'PRICES' && prerequisiteRange) {
        // 最低金额
        const price = parseInt(prerequisiteRange);
        const prerequisiteRange2 = getTextToLang(TextA.minimum_price, 'price', currencySymbol + price);
        minimum_rule = prerequisiteRange2;
    }
    if (prerequisite === 'QUANTITY' && prerequisiteRange) {
        // 最低数量
        const num = parseInt(prerequisiteRange);
        const prerequisiteRange2 = getTextToLang(TextA['minimum_num'], '{num}', num);
        minimum_rule = prerequisiteRange2;
    }
    // 积分
    const points = sqlItemData?.points;
    // 优惠
    const coupon = sqlItemData?.coupon;
    // 复制
    const copyHandle = () => {
        if (!coupon) {
            return;
        }
        copyText(coupon);
        try {
            const dataLayer2 = dataLayer_copy || {
                event: 'uaEvent',
                event_name: 'copy_promo_code',
                title_name: coupon,
                button_name: TextA.coupon,
                position: 'Swap EcoCredits for Splendid Gifts',
            };
            gtm.push(dataLayer2);
        } catch (error) {}
        return EfMessage.success(TextA.copy_success1);
    };
    const couponName2 = showCouponName ? sqlItemData?.couponName || TextA.coupon : TextA.coupon;
    return (
        <>
            <div className={classes}>
                <div className={`${prefixCls}-img`}>
                    <div className={`${prefixCls}-img-in`}>
                        <EfImg pc={pc2} />
                    </div>
                    <div className={`${prefixCls}-discount`}>
                        <div className={`${prefixCls}-discount-in`}>
                            {!isPercentage && <div className={`${prefixCls}-discount-symbol-1`}>{currencySymbol}</div>}
                            <div className={`${prefixCls}-discount-number`}>{sqlItemData?.amount}</div>
                            {isPercentage && <div className={`${prefixCls}-discount-symbol-2`}>%</div>}
                            <div className={`${prefixCls}-discount-off`}>{TextA.off}</div>
                        </div>
                        {minimum_rule && <div className={`${prefixCls}-discount-in2`}>{minimum_rule}</div>}
                    </div>
                </div>
                <div className={`${prefixCls}-msg`}>
                    <div className={`${prefixCls}-msg-title`}>{couponName2}</div>
                    {coupon && (
                        <div className={`${prefixCls}-coupon-title`} onClick={copyHandle}>
                            <span>{coupon}</span>
                            <IconCopy />
                        </div>
                    )}
                    {!!points && (
                        <div className={`${prefixCls}-msg-desc`}>
                            {points}&nbsp;
                            {TextA.points}
                        </div>
                    )}
                </div>
            </div>
            <EfMessageGlobal />
        </>
    );
};

export default EfCouponTop;
